<template>
    <div id="biography"></div>
    <div>
        <img id="logo" src='~@/assets/logo.png' alt=''>
    </div>
    <div id="menus">
        <button v-for="item in items" :key="item.id" :value="item.value">{{ item.value }}</button>
    </div>
    <div id="greeting">
        <p style="font-size: 50px;color: beige;">Believe you have the talent to make it.</p>
        <p style="font-size: 30px;color: azure; margin-top: 30px;">More about me</p>
        <img src='~@/assets/more.png' alt=''>
    </div>
</template>

<script>
    export default {
        name: 'BiographyData',
        data() {
            return {
                items: [
                    {'id': 0, 'value': '船头灯'},
                    {'id': 1, 'value': '项目展示'},
                    {'id': 2, 'value': '作品集'}
                ]
            }
        }
    }
</script>

<style>
    #biography {
        background: url('~@/assets/bg.jpg') center no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        position: fixed;
    }
    #logo {
        width: 114px;
        height: 40px;
        margin-left: 60px;
        margin-top: 20px;
        float: left;
        position: relative;
    }
    #menus {
        margin-right: 100px;
        margin-top: 30px;
        float: right;
        position: relative;
    }
    #menus button {
        background: none;
        border: 0px;
        font-size: 18px;
        color: antiquewhite;
        margin: 5px;
        margin-left: 10px;
        margin-right: 10px;
    }
    #greeting {
        position: absolute;
        width: 100%;
        margin-top: 500px;
    }
    #greeting img {
        width: 35px;
        height: 30px;
        margin-top: 20px;
    }
</style>